/* src/app/modules_v2/booking/availability/components/location-blocks/location-blocks.component.css */
.blocks-container {
  padding: 20px;
}
h3 {
  color: var(--cf-chrome);
  margin-bottom: 16px;
}
/*# sourceMappingURL=location-blocks.component.css.map */
